import React, { useState, useRef } from 'react';
type Testimonial = {
  quote: string;
  name: string;
  company: string;
};
const testimonials: Testimonial[] = [{
  quote: 'Precise Transcripts delivers flawless work every time. Their turnaround speed is unmatched.',
  name: 'Corporate Client',
  company: 'New York, NY'
}, {
  quote: 'HIPAA-compliant, secure, and incredibly accurate. Our go-to for all medical transcription.',
  name: 'Healthcare Provider',
  company: 'New Jersey'
}, {
  quote: 'The translation quality across multiple languages has been exceptional. Highly recommended.',
  name: 'Legal Firm',
  company: 'Connecticut'
}];
function StarRating() {
  return <div className="flex gap-1 mb-4" aria-label="5 out of 5 stars" data-id="element-153">
      {[1, 2, 3, 4, 5].map(star => <span key={star} style={{
      color: '#C8962E'
    }} aria-hidden="true" data-id="element-154">
          ★
        </span>)}
    </div>;
}
function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <div className="bg-white rounded-xl shadow-md p-8 flex flex-col h-full" data-id="element-155">
      <StarRating data-id="element-156" />
      <p className="italic text-sm leading-relaxed flex-1 mb-6" style={{
      color: '#1E1E1E'
    }} data-id="element-157">
        "{testimonial.quote}"
      </p>
      <div data-id="element-158">
        <p className="font-bold text-base" style={{
        color: '#1B2A4A'
      }} data-id="element-159">
          {testimonial.name}
        </p>
        <p className="text-gray-500 text-sm" data-id="element-160">{testimonial.company}</p>
      </div>
    </div>;
}
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef<number | null>(null);
  const touchEndX = useRef<number | null>(null);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.changedTouches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    touchEndX.current = e.changedTouches[0].clientX;
    if (touchStartX.current !== null && touchEndX.current !== null) {
      const diff = touchStartX.current - touchEndX.current;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          setCurrentIndex(prev => Math.min(prev + 1, testimonials.length - 1));
        } else {
          setCurrentIndex(prev => Math.max(prev - 1, 0));
        }
      }
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };
  return <section className="w-full py-20 px-4" style={{
    backgroundColor: '#F5F6FA'
  }} id="reviews" aria-label="Client testimonials" data-id="element-161">
      <div className="max-w-6xl mx-auto" data-id="element-162">
        {/* Heading */}
        <h2 className="font-bold text-4xl text-center mb-12" style={{
        color: '#1B2A4A'
      }} data-id="element-163">
          What Our Clients Say
        </h2>

        {/* Desktop: 3 columns */}
        <div className="hidden md:grid grid-cols-3 gap-6" data-id="element-164">
          <TestimonialCard testimonial={testimonials[0]} data-id="element-165" />
          <TestimonialCard testimonial={testimonials[1]} data-id="element-166" />
          <TestimonialCard testimonial={testimonials[2]} data-id="element-167" />
        </div>

        {/* Mobile: Swipeable carousel */}
        <div className="md:hidden" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} aria-live="polite" data-id="element-168">
          <TestimonialCard testimonial={testimonials[currentIndex]} data-id="element-169" />

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6" role="tablist" aria-label="Testimonial navigation" data-id="element-170">
            {testimonials.map((_, idx) => <button key={idx} role="tab" aria-selected={idx === currentIndex} aria-label={`Testimonial ${idx + 1}`} onClick={() => setCurrentIndex(idx)} className="w-2.5 h-2.5 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1" style={{
            backgroundColor: idx === currentIndex ? '#2DA5A0' : '#d1d5db'
          }} data-id="element-171" />)}
          </div>
        </div>
      </div>
    </section>;
}